import { getState } from "../../../../state/store";
import { selectLocations } from "../../../../state/selectors";

import {
  appApplicationType as adminPotalAppType,
  appUserRoles as adminPortalRoles
} from "../../../../consts";
import { appsUtil, arrayUtil, dateUtil } from "../../../../utils";

const getConfigLocation = (config) => {
  const market = config?.markets?.length === 1 ? config?.markets[0] : null;
  const locationsByMarket = market ? selectLocations(market)(getState()) : [];
  const configLocationId = config?.locationId;

  const locationConfig =
    market && locationsByMarket?.length && configLocationId
      ? locationsByMarket.find((loc) => {
          return loc.id === configLocationId;
        })
      : null;

  const location = locationConfig ? { id: locationConfig.id, value: locationConfig?.name } : null;

  return location;
};

const getUserGroups = (rolesConfig) => {
  return rolesConfig.map((config) => {
    const group = {
      markets: config.market?.map((m) => m?.id) ?? [],
      locationId: config?.location?.id ?? null,
      appType: config.application?.id,
      name: config.role?.id,
      activeFrom: config.from,
      activeTo: config.to
    };

    return group;
  });
};

const prepareUserGroups = (groups) => {
  return groups.map((config) => {
    const group = {
      ...config,
      activeFrom: dateUtil.toTimestampNoTimezone(config?.activeFrom),
      activeTo: dateUtil.toTimestampNoTimezone(config?.activeTo)
    };

    return group;
  });
};

const tranformGroups = (groups) => {
  return (
    groups?.map((config, index) => {
      const rolesConfig = {
        id: index,
        market:
          config.markets?.map((m) => {
            return { id: m, value: m };
          }) ?? [],
        location: getConfigLocation(config),
        application: { id: config.appType, value: appsUtil.getAppName(config.appType) },
        role: { id: config.name, value: config.name },
        from: config?.activeFrom,
        to: config?.activeTo
      };

      return rolesConfig;
    }) ?? []
  );
};

const validateConfig = (rolesConfig) => {
  const errorList = [];

  rolesConfig.forEach((config) => {
    const isAdminAppSelected = config.application?.id === adminPotalAppType.id;
    const isAdminRoleSelected = config.role?.id === adminPortalRoles.Admin;

    let isConfigValid = config.application && config.role;

    if (isAdminAppSelected) {
      if (!isAdminRoleSelected) {
        isConfigValid = isConfigValid && config.market.length;
      }
    } else {
      isConfigValid = isConfigValid && config.market.length && config.from && config.to;
    }

    if (!isConfigValid) {
      errorList.push({
        id: config.id,
        application: !config.application,
        market: !config.market?.length,
        role: !config.role,
        from: !config.from,
        to: !config.to
      });
    }
  });

  return errorList;
};

const getRolesConfigDuplicateErrors = (rolesConfig) => {
  const errorList = [];

  const applicationsSet = new Set(
    rolesConfig
      .filter((config) => config.application?.value)
      .map((config) => config.application.value)
  );

  const applicationsList = [...applicationsSet];

  if (!applicationsList?.length) {
    return [];
  }

  applicationsList.forEach((application) => {
    const applicationRoles = rolesConfig
      .filter((config) => config.application?.value === application && config.role?.value)
      .map((config) => {
        return { id: config.id, role: config.role.value };
      });

    const duplicatedRoles = arrayUtil.findDuplicatedValues(
      applicationRoles.map((config) => config.role)
    );

    if (duplicatedRoles) {
      duplicatedRoles.forEach((role) => {
        const configIds = applicationRoles
          .filter((config) => config.role === role)
          .map((config) => config.id);

        errorList.push({ application, role, configIds });
      });
    }
  });

  return errorList;
};

export const rolesConfigUtils = {
  getUserGroups,
  prepareUserGroups,
  tranformGroups,
  validateConfig,
  getRolesConfigDuplicateErrors
};
